import * as z from 'zod';

export const pendingChangeSchema = z.looseObject({
  id: z.string().nullish(),
  status: z.string().nullish(),
});
export type PendingChange = z.infer<typeof pendingChangeSchema>;

export const presignSlotSchema = z
  .object({
    key: z.string().nullish(),
    upload_url: z.string().nullish(),
    public_url: z.string().nullish(),
    error: z.string().nullish(),
  })
  .loose();
export type PresignSlot = z.infer<typeof presignSlotSchema>;

export interface UploadedImage {
  key: string;
  publicUrl: string;
}

export interface UpsertImageItem {
  image_type?: string | undefined;
  locale?: string | undefined;
  image_id?: string | undefined;
  link?: string | undefined;
}

export const upsertImageItemResultSchema = z
  .object({
    image_id: z.string().nullish(),
    image_type: z.string().nullish(),
    path: z.string().nullish(),
    pending_change: pendingChangeSchema.nullish(),
  })
  .loose();
export type UpsertImageItemResult = z.infer<typeof upsertImageItemResultSchema>;
